/**
 * @file inex.tsx
 *
 * @fileoverview This is the job wizard page for adding a new job in the wizard.
 */
import JobiqoJobWizardJobFormPage, {
  getServerSideProps,
} from '~/jobiqo/pages/job/wizard/form';
export default JobiqoJobWizardJobFormPage;
export { getServerSideProps };
